import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProjectActionType } from "../components/report/config/potential-repeat/types";
interface RepeatReportState {
    actionTaken: ActionTaken[];
    loading: boolean;
    success: boolean;
}
interface ActionTaken {
    orderId: string;
    actionType?: ProjectActionType;
    formNumber?: number;
    jobNumber?: number;
    isDismissed?: boolean;
}

const initialState: RepeatReportState = {
    actionTaken: [],
    loading: false,
    success: false,
};

const repeatReportSlice = createSlice({
    name: "repeatReport",
    initialState,
    reducers: {
        loading(state) {
            state.loading = true;
            state.success = false;
        },
        loaded(state) {
            state.loading = false;
        },
        updateActionTaken(
            state,
            action: PayloadAction<ActionTaken>
        ) {
            const existingIndex = state.actionTaken.findIndex(
                (item) => item.orderId === action.payload.orderId
            );

            if (existingIndex !== -1) {
                state.actionTaken[existingIndex] = { ...state.actionTaken[existingIndex], ...action.payload };
            } else {
                state.actionTaken.push(action.payload);
            }

            state.loading = false;
            state.success = true;
        },
    },
});

export const { updateActionTaken, loading, loaded } = repeatReportSlice.actions;

export const setActionTaken =
    ({ orderId, actionType, formNumber, jobNumber, isDismissed }: ActionTaken) => async (dispatch) => {
        dispatch(loading());
        let payload = { orderId, isDismissed } as ActionTaken;
        if (!!actionType) {
            payload.actionType = actionType;
        }
        if (!!formNumber) {
            payload.formNumber = formNumber;
        }
        if (!!jobNumber) {
            payload.jobNumber = jobNumber;
        }
        dispatch(updateActionTaken(payload));
        return true;
    };

// Selectors
export const selectDismissed = (state: any, orderId: string) => {
    return state.repeatReport.actionTaken.find(item => item.orderId === orderId)?.isDismissed;
};
export const selectActionTaken = (state: any, orderId: string) => {
    return state.repeatReport.actionTaken.find(item => item.orderId === orderId)?.actionType as ProjectActionType;
};
export const selectFormNumber = (state: any, orderId: string) => {
    return state.repeatReport.actionTaken.find(item => item.orderId === orderId)?.formNumber as number;
};
export const selectJobNumber = (state: any, orderId: string) => {
    return state.repeatReport.actionTaken.find(item => item.orderId === orderId)?.jobNumber as number;
};

export const selectLoading = (state: any) =>
    state.repeatReport.loading === true;

export const selectSuccess = (state: any) => state.repeatReport.success;

export default repeatReportSlice.reducer;